import { h as __h } from "preact";
import { Component, h } from "preact";
import html from "~/util/html.js";
import { ModalProvider } from "~/util/modal.js";
import { PopoverProvider } from "~/util/popover.js";
import { LocationProvider, Route, Router } from "~/util/router.js";
import Title from "~/util/title.js";
import { Alerts } from "~/component/Alerts.js";
import ErrorBoundary from "~/component/ErrorBoundary.js";
import { ensureLoggedIn, ensureLoggedOut } from "~/component/Guard.js";
import Dashboard, { PersonalDashboard } from "./Dashboard.js";
import Email from "~/page/Email.js";
import { ForgotPassword, ForgotPasswordReset } from "~/page/Forgot.js";
import Login from "~/page/Login.js";
import { SignUp, SignUpConfirm } from "~/page/Signup.js";
/** @import { Props as LoginProps } from "~/page/Login.js"; */
import SsoCallback from "~/page/SsoCallback.js";
import SsoChoose from "~/page/SsoChoose.js";
import SsoLogin from "~/page/SsoLogin.js";
/** @import { Props as SsoLoginProps } from "~/page/SsoLogin.js"; */

export default class Admin extends Component {
  get routes() {
    return [
    // public pages
    h(Route, {
      path: "/signup/confirm/",
      component: ensureLoggedOut(SignUpConfirm),
      props: {}
    }), h(Route, {
      path: "/signup/",
      component: ensureLoggedOut(SignUp),
      props: {}
    }), h(Route, {
      path: "/forgot/reset/",
      component: ensureLoggedOut(ForgotPasswordReset),
      props: {}
    }), h(Route, {
      path: "/forgot/",
      component: ensureLoggedOut(ForgotPassword),
      props: {}
    }), h(Route, {
      path: "/sso/callback/",
      component: ensureLoggedOut(SsoCallback),
      props: {}
    }),
    // not ensureLoggedOut: native users reach this in a system browser that may be logged in
    h(Route, {
      path: "/login/sso/choose/",
      component: SsoChoose,
      props: {}
    }), h(Route, {
      path: "/email/",
      component: Email,
      props: {}
    }), h(/** @type {typeof Route<SsoLoginProps>} */Route, {
      path: "/login/sso/",
      component: ensureLoggedOut(SsoLogin),
      props: {}
    }), h(/** @type {typeof Route<LoginProps>} */Route, {
      path: "/login/",
      component: ensureLoggedOut(Login),
      props: {}
    }),
    // private pages
    h(Route, {
      path: "/web",
      component: ensureLoggedIn(PersonalDashboard),
      props: {}
    }), h(/** @type {typeof Route<import("./Dashboard.js").DashboardProps>} */Route, {
      path: "/org/:orgId/",
      component: ensureLoggedIn(Dashboard),
      props: {}
    }), h(/** @type {typeof Route<import("./Dashboard.js").DashboardProps>} */Route, {
      path: "/",
      component: ensureLoggedIn(Dashboard),
      props: {}
    })];
  }
  render() {
    return [__h(Title, {
      title: "Admin"
    }), __h(ErrorBoundary, {}, __h(LocationProvider, {}, " ", h(Router, null, this.routes), " "), __h(Alerts, {
      offset: 0
    }), __h(PopoverProvider, {}), __h(ModalProvider, {}))];
  }
}